import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
export function Register() {
  const {
    register
  } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = (location.state as {
    from?: string;
  })?.from || '/account';
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState<string | null>(null);
  const update = (field: string, value: string) => setForm(prev => ({
    ...prev,
    [field]: value
  }));
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (form.password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    const result = register({
      firstName: form.firstName,
      lastName: form.lastName,
      email: form.email,
      phone: form.phone,
      password: form.password
    });
    if (!result.success) {
      setError(result.error || 'Registration failed.');
      return;
    }
    toast.success('Account created!', {
      description: 'Welcome to Beach Shop.'
    });
    navigate(redirectTo);
  };
  return <div className="min-h-[80vh] bg-gray-50 flex items-center justify-center py-12 px-4" data-id="element-777">
      <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 max-w-md w-full" data-id="element-778">
        <div className="text-center mb-6" data-id="element-779">
          <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-780">
            Create your account
          </h1>
          <p className="text-gray-500 text-sm" data-id="element-781">
            Save your details for faster checkout and track your orders.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-782">
          <div className="grid grid-cols-2 gap-3" data-id="element-783">
            <div data-id="element-784">
              <label htmlFor="reg-fn" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-785">
                First name
              </label>
              <input id="reg-fn" type="text" required value={form.firstName} onChange={e => update('firstName', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-786" />
            </div>
            <div data-id="element-787">
              <label htmlFor="reg-ln" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-788">
                Last name
              </label>
              <input id="reg-ln" type="text" required value={form.lastName} onChange={e => update('lastName', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-789" />
            </div>
          </div>

          <div data-id="element-790">
            <label htmlFor="reg-email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-791">
              Email
            </label>
            <input id="reg-email" type="email" required value={form.email} onChange={e => update('email', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-792" />
          </div>

          <div data-id="element-793">
            <label htmlFor="reg-phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-794">
              Phone
            </label>
            <div className="flex" data-id="element-795">
              <span className="inline-flex items-center px-3 rounded-l-lg border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm" data-id="element-796">
                +960
              </span>
              <input id="reg-phone" type="tel" required placeholder="7XXXXXX" pattern="[79][0-9]{6}" value={form.phone} onChange={e => update('phone', e.target.value)} className="flex-1 min-w-0 px-3 py-2 rounded-r-lg border border-gray-300 focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-797" />
            </div>
          </div>

          <div data-id="element-798">
            <label htmlFor="reg-pw" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-799">
              Password
            </label>
            <input id="reg-pw" type="password" required minLength={6} value={form.password} onChange={e => update('password', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-800" />
          </div>

          <div data-id="element-801">
            <label htmlFor="reg-pw2" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-802">
              Confirm password
            </label>
            <input id="reg-pw2" type="password" required value={form.confirmPassword} onChange={e => update('confirmPassword', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-803" />
          </div>

          {error && <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg p-3" data-id="element-804">
              {error}
            </div>}

          <button type="submit" className="w-full bg-red-600 text-white py-3 rounded-lg font-medium hover:bg-red-700 transition-colors flex items-center justify-center gap-2" data-id="element-805">
            Create Account <ArrowRight className="w-4 h-4" data-id="element-806" />
          </button>
        </form>

        <div className="mt-6 pt-6 border-t border-gray-100 text-center text-sm text-gray-600" data-id="element-807">
          Already have an account?{' '}
          <Link to="/login" state={{
          from: redirectTo
        }} className="text-red-600 font-medium hover:underline" data-id="element-808">
            Sign in
          </Link>
        </div>
      </div>
    </div>;
}